import CustomLoaderSmall from "../../../../components/Layout/CustomLoaderSmall";
import {Helmet} from "react-helmet";
import ChatSideBar from "../../../../components/Layout/Graph & Tables/ChatSideBar";
import {AIModel} from "../../../../components/Layout/DropdownMenu/ChatMenuSelector";
import ChatMenuSelector from "../../../../components/Layout/DropdownMenu/ChatMenuSelector";
import {useSelector, } from "react-redux";
import {NavLink, useParams} from "react-router-dom";
import {LucideFilePlus, ClipboardList, SheetIcon, MicIcon, MicOffIcon, ArrowBigRightDash, CalendarDaysIcon} from "lucide-react"
import {useAzureSpeech} from "../../Rev1Chat/ChatPage/useAzureSpeech";
import { PRODUCTION_PDF_URL} from "../../../../util/urlconstants"

import {
    useSendSafetyAIMessageMutation,
    useSendSummaryAIMessageMutation,
    useGetPdfIngestedQuery,
    useDeletePdfIngestedMutation,
    useDeleteEntirePdfMutation,
    useSendProposalDraftMutation,
    useGetExcelIngestedFilesQuery,
    useSendAIExcelMessageMutation,
} from "../../../../features/chatapiSlice";

import {useGetProjectIdQuery,
        useChatProjectAdvisorMutation,
        useListProjectConversationByIdQuery} from "../../../../features/conversationapiSlice";

import {useSendAIEquipmentMessageMutation} from "../../../../features/equipmentApiSlice";
import React, { useState, useEffect, useRef} from "react";

import ChatInput from "./ChatInput";
import {ChatMessageList} from "./ChatMessageList";
import PromptSelector from "../../../../components/Layout/PromptSelector";
import {motion} from "framer-motion";
import PdfOutlinePanel from "../../PdfOutlinePanel";
import {toast} from "react-toastify";
import {useAzureTextToSpeech} from "../../useAzureTextToSpeech";
import { sanitizeTextForTTS} from "../../sanitizeTextForTTS";
import {useGetPlayWrightQuerybyIdQuery} from "../../../../features/playwrightApiSlice";

const promptList = [
    { id: "1", title: "Understand scope of work", description: "Please summarize contract for this project" },
    { id: "2", title: "List key obligations", description: "Extract main responsibilities and obligations" },
    { id: "3", title: "Identify risks and mitigation", description: "Tell me about OSHA Fall protection requirements" },
    { id: "4", title: "Payment and Terms", description: "How are payments handled for this project?" },
    { id: "5", title: "Safety in project workspace", description: "Please explain OSHA trench requirements ?" },
];

/* ---------------- AI Selection ---------------- */
const models: AIModel[] = [
    {
        id: "summary-gpt",
        name: "Summary AI",
        description: "Specialized for providing contract summary",
        icon: "tree",
    },
    {
        id: "safety-ai",
        name: "Safety AI",
        description: "Expert in OSHA law and safety regulations",
        icon: "sparkles",
    },
    {
        id: "project-ai",
        name: "Project AI",
        description: "Ask about ongoing project",
        icon: "folder",
    },
    {
        id: "equipment-ai",
        name: "Equipment AI",
        description: "Ask about equipment",
        icon: "tractor",
    },
    {
        id: "advisor-ai",
        name: "Advisor AI",
        description: "Your personal strategic advisor",
        icon: "userround",
    },
    {
        id: "proposal-ai",
        name: "Proposal AI",
        description: "Aid in drafting project proposal",
        icon: "construction",
    },
    {
        id: "tabular data-ai",
        name: "Tabular Data AI",
        description: "Works with Excel files",
        icon: "filespreadsheet",
    },
];

export function ConversationMainScreen() {
    const [messages, setMessages] = useState<any[]>([]);
    const [sessionId] = useState("session-1234");
    const [inProgressMessage, setInProgressMessage] = useState<any>(null);
    const [isDocumentMode, setIsDocumentMode] = useState(false);
    const [openPdfList, setOpenPdfList] = useState(false);
    const [previewPdfId, setPreviewPdfId] = useState<string | null>(null);
    const [isPdfSideBarOpen, setIsPdfSideBarOpen] = useState(false);
    const { id } = useParams();
    const projectId = String(id);

    const {data: projectData} = useGetPlayWrightQuerybyIdQuery<any>(projectId);


    /* ---------------- AI Redux Toolkit call ---------------- */

    const [sendSafetyAIMessage, {isLoading}] = useSendSafetyAIMessageMutation();
    const [sendSummaryAIMessage] = useSendSummaryAIMessageMutation();
    const [chatProjectAdvisor] = useChatProjectAdvisorMutation();
    const [sendEquipmentAIMessage] = useSendAIEquipmentMessageMutation();
    const [sendProposalAIMessage] = useSendProposalDraftMutation();

    const keyword = useParams();

    const {
        data: pdfs = [],
        isLoading: isPdfLoading,
        isError: isPdfError,
        refetch,
    } = useGetPdfIngestedQuery({keyword});

    const {id: sessionIdParam} = useParams();


    const {
        data: conversationMessages,
        isLoading: isMessagesLoading,
    } =  useListProjectConversationByIdQuery(sessionIdParam, {
        refetchOnMountOrArgChange: true
    });

    useEffect(() => {
        if (conversationMessages && conversationMessages.length > 0) {
            setMessages(conversationMessages);
        }
    }, [conversationMessages]);

    const [deleteEmbedPdf] = useDeletePdfIngestedMutation();
    const [deleteEntirePdf] = useDeleteEntirePdfMutation();
    const [sendAIExcelMessage] = useSendAIExcelMessageMutation();

    const appendMessage = (msg:any) => {
        setMessages(prev => [...prev, msg]);
    }

    const [selectedTableName, setSelectedTableName] = useState<string | null>(null);
    const [selectedTableSheetId, setSelectedTableSheetId] = useState<string | null>(null);
    const [selectedModelId, setSelectedModelId] = useState("contract-ai");
    const [selectedPromptId, setSelectedPromptId] = useState<string>();
    const [inputValue, setInputValue] = useState("");

    // ExcelTable List collection
    const {
        data: excelTables = [],
        isLoading: isExcelTableLoading,
        isError: isExcelTableError,
    } = useGetExcelIngestedFilesQuery({}, {
        skip: selectedModelId !== "tabular data-ai",
    });

    // Authentication
    const {userInfo} = useSelector((state: any) => state.auth);

    // Use Azure Speech Service with sanitize Asterisk in conversation BOT
    const {speak: speakSpeech, stopSpeech: stopTheSpeech, resumeSpeech, pauseSpeech, isPaused, isPlaying } = useAzureTextToSpeech();

    const handleAssistantAzureMessageHandler = (text: string) => {
        if (!text?.trim()) return;

        const cleanText = sanitizeTextForTTS(text);

        speakSpeech(cleanText);
    }

    // Handle Scrolling upon selection
    const messageEndRef = useRef<HTMLDivElement>(null);

    const scrollToBottom = () => {
        messageEndRef.current?.scrollIntoView({behavior: "smooth"});
    }

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    useEffect(() => {
        scrollToBottom()
    }, [sessionIdParam]);

    // When a prompt is selected from the dropdown
    const handleSelectedPrompt = (promptId: string) => {
        setSelectedPromptId(promptId);
        const prompt = promptList.find((prompt) => prompt.id === promptId);
        if (prompt) {
            setInputValue(prompt.description);
        }
    }

    const togglePdfSidebar = () => {
        setIsPdfSideBarOpen(prev => !prev);
    }

    useEffect(() => {
        console.log("📝 inputValue:", inputValue)
    }, [inputValue])

    // ✅ Handles toggle change
    const handleSwitch = (enabled: boolean) => {
        setIsDocumentMode(enabled);
    };

    const handleProjectAIMessage = async (message: string) => {
        if (!message.trim()) return;

        const userMessage = {
            role: "user",
            messageContent: message,
            createdAt: new Date().toISOString(),
        }

        setMessages((prev) => [...prev, userMessage]);
        setInProgressMessage({role:"assistant", messageContent: "..."});

        try {
            const session = {sessionId, messages : [userMessage]};
            const response = await chatProjectAdvisor(session).unwrap();

            console.log("📄 Full Semantic AI Response:", response);

            // @ts-ignore
            if (response?.messageContent) {
                const assistantMessage = {
                    role: "assistant",
                    // @ts-ignore
                    messageContent: response.messageContent,
                    // @ts-ignore
                    createdAt: response.createdAt,
                    // @ts-ignore
                    sources: response.sources,
                };
                setMessages((prev) => [...prev, assistantMessage]);
            }

        } catch (err) {
            console.error("❌ Error sending semantic AI message:", err);
        } finally {
            setInProgressMessage(null);
        }
    }

    const handleEquipmentAIMessage = async (snippet: string) => {
        if (!snippet.trim()) return;

        const userMessage = {
            role: "user",
            messageContent: snippet,
            createdAt: new Date().toISOString(),
        };

        setMessages((prev) => [...prev, userMessage]);
        setInProgressMessage({role: "assistant", messageContent: "..."});

        try {
            const session = {sessionId, messages: [userMessage]};
            const response: any = await sendEquipmentAIMessage(session).unwrap();

            console.log("📄 Full Semantic AI Response:", response);
            console.log("🔗 Sources:", response.sources);

            if (response?.messageContent) {
                const assistantMessage = {
                    role: "assistant",
                    messageContent: response.messageContent,
                    createdAt: response.createdAt,
                    sources: response.sources,
                };
                setMessages((prev) => [...prev, assistantMessage]);
                //   setSources(response.sources);
            }
        } catch (err) {
            console.error("❌ Error sending semantic AI message:", err);
        } finally {
            setInProgressMessage(null);
        }
    }

    const handleExcelDataMessageHandler = async (snippet: string) => {
        if (!snippet.trim()) return;

        if (!selectedTableSheetId) {
            toast.warning("Please select an Excel Table first.")
            return;
        }

        const userMessage = {
            role: "user",
            messageContent: snippet,
            createdAt: new Date().toISOString(),
        };

        setMessages((prev) => [...prev, userMessage]);
        setInProgressMessage({role: "assistant", messageContent: "..."});

        const payload = {
            sheetId: selectedTableSheetId,
            question: snippet,
            chatSession: {
                sessionId: selectedTableSheetId,
                title: selectedTableName ?? "Excel Dataset",
                messages: [userMessage],
            },
        };

        try {

            const response: any = await sendAIExcelMessage(payload).unwrap();

            console.log("📄 Full Tabular AI Response:", response);
            console.log("🔗 Sources:", response.sources);

            if (response?.messageContent) {
                const assistantMessage = {
                    sessionId: selectedTableSheetId,
                    role: "assistant",
                    messageContent: response.messageContent,
                    createdAt: response.createdAt,
                    // sources: response.sources,
                };
                setMessages((prev) => [...prev, assistantMessage]);
                //   setSources(response.sources);
            }
        } catch (err) {
            console.error("❌ Error sending excel AI message:", err);
        } finally {
            setInProgressMessage(null);
        }
    }

    const handleProposalDraftAIMessage = async (messageContent: string) => {
        if (!messageContent.trim()) return;

        const userMessage = {
            role: "user",
            sessionId: sessionId,
            messageContent: messageContent,
            createdAt: new Date().toISOString(),
        };

        setMessages((prev) => [...prev, userMessage]);
        setInProgressMessage({role: "assistant", messageContent: "..."});

        try {
            const session = {sessionId, messages: [userMessage]};

            const response: any = await sendProposalAIMessage(session).unwrap();

            console.log("📄 Full Semantic AI Response:", response);
            console.log("🔗 Sources:", response.sources);

            if (response?.messageContent) {
                const assistantMessage = {
                    role: "assistant",
                    messageContent: response.messageContent,
                    createdAt: response.createdAt,
                    sources: response.sources,
                };
                setMessages((prev) => [...prev, assistantMessage]);

            }
        } catch (err) {
            console.error("❌ Error sending semantic AI message:", err);
        } finally {
            setInProgressMessage(null);
        }
    }

    const handleAdvisorAIMessage = async (message: string) => {
        if (!message.trim()) return;

        if (!projectData?.sessionId) {
            toast.error("Conversation session was not found")
            return;
        }

        const userMessage = {
            role: "user",
            sessionId: projectData.sessionId,
            messageContent: message,
            createdAt: new Date().toISOString(),
        };

        // Confirm if sessionId exist within ConversationMessage
        console.log(projectData.sessionId);

        // Save user message locally
      //  appendMessage(userMessage);
        setMessages((prev) => [...prev, userMessage]);
        setInProgressMessage({role: "assistant", messageContent: "..."});

        try {
            const payload = {sessionId: userMessage.sessionId,
                            messageContent: message
            };

            console.log("Advisor request payload:", payload);

            const response: any = await chatProjectAdvisor(payload).unwrap();

            if (response?.messageContent) {
                const assistantMessage = {
                    sessionId: response.sessionId,
                    role: "assistant",
                    messageContent: response.messageContent,
                    createdAt: response.createdAt,
                    contextUsed: response.contextUsed,
                    sources: response.sources ?? [],
                };

                // Save assistant message locally
             //   appendMessage(assistantMessage);
                setMessages((prev) => [...prev, assistantMessage]);
            }
        } catch (err) {
            console.error("❌ Error sending semantic AI message:", err);
        } finally {
            setInProgressMessage(null);
        }
    }

    const handleSummaryAIMessage = async (snippet: string) => {
        if (!snippet.trim()) return;

        const userMessage = {
            role: "user",
            messageContent: snippet,
            createdAt: new Date().toISOString(),
        };

        setMessages((prev) => [...prev, userMessage]);
        setInProgressMessage({role: "assistant", messageContent: "..."});

        try {
            const session = {sessionId, messages: [userMessage]};

            const response: any = await sendSummaryAIMessage(session).unwrap();

            console.log("📄 Full Semantic AI Response:", response);
            console.log("🔗 Sources:", response.sources);

            if (response?.messageContent) {
                const assistantMessage = {
                    role: "assistant",
                    messageContent: response.messageContent,
                    createdAt: response.createdAt,
                    sources: response.sources,
                };
                setMessages((prev) => [...prev, assistantMessage]);
                //   setSources(response.sources);
            }
        } catch (err) {
            console.error("❌ Error sending semantic AI message:", err);
        } finally {
            setInProgressMessage(null);
        }
    };

    const handleSafetyAIMessage = async (snippet: string) => {
        if (!snippet.trim()) return;

        const userMessage = {
            role: "user",
            messageContent: snippet,
            createdAt: new Date().toISOString(),
        };

        setMessages((prev) => [...prev, userMessage]);
        setInProgressMessage({role: "assistant", messageContent: "..."});

        try {
            const session = {sessionId, messages: [userMessage]};
            const response: any = await sendSafetyAIMessage(session).unwrap();

            console.log("📄 Full Semantic AI Response:", response);
            console.log("🔗 Sources:", response.sources);

            if (response?.messageContent) {
                const assistantMessage = {
                    role: "assistant",
                    messageContent: response.messageContent,
                    createdAt: response.createdAt,
                    sources: response.sources,
                };
                setMessages((prev) => [...prev, assistantMessage]);
                //   setSources(response.sources);
            }
        } catch (err) {
            console.error("❌ Error sending semantic AI message:", err);
        } finally {
            setInProgressMessage(null);
        }
    };

    const handleAISendBasedOnModel = async (text: string) => {
        console.log("Selected Model:", selectedModelId);

        switch (selectedModelId) {

            case "equipment-ai":
                await handleEquipmentAIMessage(`${text}`);
                break;

            case "summary-gpt":
                await handleSummaryAIMessage(`${text}`);
                break;

            case "safety-ai":
                await handleSafetyAIMessage(`${text}`);
                break;

            case "project-ai":
                await handleProjectAIMessage(`${text}`);
                break;

            case "advisor-ai":
                await handleAdvisorAIMessage(`${text}`);
                break;

            case "proposal-ai":
                await handleProposalDraftAIMessage(`${text}`);
                break;

            case "tabular data-ai":
                await handleExcelDataMessageHandler(`${text}`);
                break;

            default:
                await handleSummaryAIMessage(text);
                break;
        }
    }

    // Hide Header
    const hasStartedChat = messages.length > 0 || inProgressMessage;

    // Handle Speech Synthesis
    const {startSpeech, stopSpeech, isListening} = useAzureSpeech({
        onResult: (text: string) => {
            setInputValue(text);
        },
        onError: () => {
            toast.error("Speech support failed")
        }
    });

    // Delete PDF
    const deletePdfHandler = async (id: any) => {
        if (window.confirm("Are you sure you want to delete this PDF now?")) {
            try {
                await deleteEntirePdf(id)
                refetch();

                toast.success("PDF deleted successfully.");

            } catch (error) {
                toast.error("Problem with deleting this PDF.");
            }
        }
    }

    // Delete Embedded PDF
    const deleteEmbedPDF = async (documentid: any) => {
        if (window.confirm("Are you sure you want to delete embedded PDF now?")) {
            try {
                await deleteEmbedPdf(documentid);
                refetch();

                toast.success("Embedded PDF deleted successfully.");

            } catch (error) {
                toast.error("Problem with deleting embedded PDF.");
            }
        }
    }

    useEffect(() => {
        if (selectedModelId !== "tabular data-ai") {
            setSelectedTableSheetId(null)
            setSelectedTableName(null);
        }
    }, [selectedModelId]);

    return (
        <main>
            <Helmet>
                <title>Chat App</title>
                <meta name="description" content="Chat App"/>
            </Helmet>
            {isLoading ? (
                <div className={"justify-center items-center py-20"}>
                    <CustomLoaderSmall />
                </div>
            ) : (
                <motion.div
                    initial={{opacity: 0, y: 60}}
                    animate={{opacity: 1, y: 0}}
                    transition={{delay: 0.2}}
                >
                    {/*Keep the h-screen to show the chat input. Do not change*/}
                    <div className={"bg-[#0A0A0A] h-screen text-white font-sans flex"}>
                        {/*<SideBar/>*/}
                        <ChatSideBar/>

                        <div className={"flex-1 flex flex-col min-w-1 bg-[#f7f7f7]"}>
                            {/*<ChatMessageExample/>*/}
                            <div
                                className="h-14 border-b border-border px-4 my-2 flex items-center justify-between flex-shrink-0">
                                <div className={" flex flex-1 justify-items-start mx-1 px-2 gap-x-4"}>
                                    <ChatMenuSelector
                                        models={models}
                                        selectedModelId={selectedModelId}
                                        onSelectModel={(id) => {
                                            console.log("Selected model:", id);
                                            setSelectedModelId(id);
                                        }}
                                    />

                                    {/*Excel Chat Dropdown list*/}
                                    {selectedModelId === "tabular data-ai" && (
                                        <div className={"flex items-center gap-2 mt-2"}>
                                            <label className={"text-sm font-medium text-gray-800"}>
                                                Select Table
                                            </label>

                                            <select className={"border rounded-md px-2 py-2 text-md bg-gray-500 min-w-[220px]"}
                                                    value={selectedTableSheetId ?? ""}
                                                    onChange={(e) => {
                                                        const sheetId = e.target.value;
                                                        const table = excelTables.find((t: any) => t.sheetId === sheetId);

                                                        setSelectedTableSheetId(sheetId);
                                                        setSelectedTableName(table?.tableName ?? "Not found");
                                                    }}>
                                                <option value={""} disabled>
                                                    Select Table
                                                </option>

                                                {isExcelTableLoading && (
                                                    <option disabled>Loading Tables...</option>
                                                )}

                                                {isExcelTableError && (
                                                    <option disabled>Error with table...</option>
                                                )}

                                                {excelTables.map((table: any) => (
                                                    <option key={table.sheetId} value={table.sheetId} >

                                                        📄 {table.tableName}
                                                    </option>
                                                ))}

                                            </select>

                                        </div>
                                    )}

                                    {/* Open PDF Ingestion if the user is admin */}
                                    {userInfo && userInfo.isAdmin && (
                                        <NavLink to={"/documentingestion"}>
                                            <LucideFilePlus size={24} color={"black"} className={"my-4 mx-2"}/>
                                        </NavLink>
                                    )}

                                    {/* Open PDF Ingestion if the user is admin */}
                                    {userInfo && userInfo.isAdmin && (
                                        <NavLink to={"/excelingestion"}>
                                            <SheetIcon size={24} color={"purple"} className={"my-4 mx-2"}/>
                                        </NavLink>
                                    )}

                                    <div className={"flex flex-1"}>
                                        <button onClick={() => setOpenPdfList(true)}
                                                className={"text-gray-800 hover:text-blue-700 my-4 flex items-center"}>
                                            <ClipboardList size={24} color={"blue"}   />
                                        </button>

                                        {/* Open Excel Document lists  if the user is admin */}
                                        {userInfo && userInfo.isAdmin && (
                                            <div className={"mx-4"}>
                                                <NavLink to={"/excellists"}>
                                                    <CalendarDaysIcon size={24} color={"black"} className={"my-4 mx-2"}/>
                                                </NavLink>
                                            </div>

                                        )}

                                        {openPdfList && userInfo?.isAdmin && (
                                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                                                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 scroll-auto">
                                                    <div className="flex justify-between items-center mb-4">
                                                        <h2 className="text-lg font-semibold text-gray-800">
                                                            Ingested PDFs
                                                        </h2>
                                                        <button
                                                            onClick={() => setOpenPdfList(false)}
                                                            className="text-gray-500 hover:text-gray-800"
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>

                                                    {isPdfLoading && <p className="text-gray-500">Loading PDFs...</p>}
                                                    {isPdfError && <p className="text-red-500">Failed to load PDFs</p>}

                                                    {!isPdfLoading && pdfs.length === 0 && (
                                                        <p className="text-gray-500">No PDFs ingested</p>
                                                    )}

                                                    <ul className="space-y-3">
                                                        {pdfs?.map((doc: any) => (
                                                            <li
                                                                key={doc.documentId}
                                                                className="border rounded-lg p-4 flex justify-between items-start"
                                                            >
                                                                <div className="text-gray-800 text-sm space-y-1">
                                                                    <p><strong>ID:</strong> {doc.documentId}</p>
                                                                    <p>📄 Pages: {doc.pageCount}</p>
                                                                    <p>🧩 Chunks: {doc.chunkCount}</p>
                                                                </div>


                                                                <div className={"flex flex-col gap-2"}>
                                                                    {/* 🔍 PREVIEW */}
                                                                    <button
                                                                        //   onClick={() => navigate(`/pdfViewer/${encodeURIComponent(doc.documentId)}`) }
                                                                        onClick={() => setPreviewPdfId(doc.documentId)}
                                                                        className={"text-blue-600 hover:text-blue-900 text-sm"}>
                                                                        Preview
                                                                    </button>

                                                                    {/* 🗑 DELETE */}
                                                                    <button
                                                                        onClick={() => deleteEmbedPDF(doc.documentId)}
                                                                        className="text-red-600 hover:text-red-800 text-sm"
                                                                    >
                                                                        Delete Embedding
                                                                    </button>

                                                                    {/* Delete PDF */}
                                                                    <button
                                                                        onClick={ () => deletePdfHandler(doc.documentId)
                                                                        }
                                                                        className="text-red-400 hover:text-red-800 text-sm"
                                                                    >
                                                                        Delete PDF
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>

                                                    {/* Preview PDF */}
                                                    {previewPdfId && (
                                                        <div className={"fixed inset-0 py-20 px-20 z-50 items-center bg-black/60"}>
                                                            <div className="bg-white rounded-xl shadow-xl w-1/4 h-fit flex flex-col">

                                                                {/* Header */}
                                                                <div className="flex justify-between items-center p-4 border-b">
                                                                    <h2 className="font-semibold text-gray-800 truncate">
                                                                        {previewPdfId}
                                                                    </h2>
                                                                    <button
                                                                        onClick={() => setPreviewPdfId(null)}
                                                                        className="text-gray-500 hover:text-gray-800"
                                                                    >
                                                                        ✕
                                                                    </button>
                                                                </div>

                                                                {/* PDF iframe change to PDF_URL for development, */}
                                                                <iframe
                                                                    src={`${PRODUCTION_PDF_URL}/${encodeURIComponent(previewPdfId)}`}
                                                                    className="flex-1 w-full"
                                                                    title="PDF Preview"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>


                                            </div>
                                        )}

                                    </div>
                                    {/* Toggle PDF list */}
                                    <button onClick={() => togglePdfSidebar()} className={"mx-auto"}>
                                        <ArrowBigRightDash size={24} className={"bg-gray-800 rounded-3xl hover:scale-125 duration-200 ease-in-out"} />
                                    </button>

                                </div>


                                <PromptSelector prompts={promptList} onSelectPrompt={handleSelectedPrompt}
                                                selectedPromptId={selectedPromptId}/>
                            </div>

                            {/* Chat Message List */}
                            <div className="flex flex-auto overflow-hidden h-screen bg-gray-50">

                                <div className="flex-1 overflow-y-auto p-4 text-gray-800 text-2xl">

                                    {/* SHOW ONLY BEFORE CHAT STARTS */}
                                    {!hasStartedChat && (
                                        <div className="flex flex-col items-center justify-center h-full text-center">

                                            <h1 className="text-5xl font-bold text-gray-800 mb-4">
                                                AI Project Assistant
                                            </h1>

                                            <p className="text-xl text-gray-500 max-w-2xl">
                                                Ask questions about contracts, safety, project planning,
                                                equipment, proposals, and tabular data.
                                            </p>

                                        </div>
                                    )}

                                    {/* SHOW CHAT AFTER MESSAGE STARTS */}
                                    {hasStartedChat && (
                                        <>
                                            <ChatMessageList
                                                messages={messages}
                                                inProgressMessage={inProgressMessage}
                                                showSources={isDocumentMode}
                                                noMessagesContent="Please ask a question on contract"
                                                onSpeakHandler={handleAssistantAzureMessageHandler}
                                                onPause={pauseSpeech}
                                                onStop={stopTheSpeech}
                                                onResume={resumeSpeech}
                                                isPlaying={isPlaying}
                                                isPaused={isPaused}
                                            />

                                            <div ref={messageEndRef}></div>

                                        </>
                                    )}

                                </div>

                                {/* PDF outline */}
                                {!isDocumentMode && isPdfSideBarOpen && (
                                    <section className="bg-white overflow-y-auto border-1 flex">

                                        <motion.div
                                            className={`relative z-10 transition-all duration-200 ease-in-out flex-shrink-0 ${
                                                isPdfSideBarOpen ? `w-54` : "w-20"
                                            }`}
                                            animate={{ width: isPdfSideBarOpen ? 340 : 40 }}
                                        >
                                            <PdfOutlinePanel messages={messages} />
                                        </motion.div>

                                    </section>
                                )}

                            </div>

                            <div className={"p-4 border-t bg-white flex items-center gap-2"}>
                                { /*Speech Synthesis*/}
                                <button
                                    onPointerDown={startSpeech}
                                    onPointerUp={stopSpeech}
                                    onTouchStart={startSpeech}
                                    onTouchEnd={stopSpeech}
                                    className={`rounded-full p-2 transition ${
                                        isListening
                                            ? "bg-red-600 text-white animate-pulse"
                                            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                    }`}
                                    title="Hold to talk">
                                    {isListening ? <MicOffIcon size={24} /> : <MicIcon size={24} />}
                                </button>

                                {/*<ChatWindow/>*/}
                                { /*Speech Recognition*/}
                                <div className="flex-1">

                                    <ChatInput onSend={(text: string) => handleAISendBasedOnModel(text)}
                                               disabled={isLoading}
                                               value={inputValue}
                                               onChange={setInputValue}
                                    />
                                    <h2 className="p-2 text-blue-700 font-medium text-sm text-center">
                                        Please note that AI agent may give inaccurate information
                                    </h2>
                                </div>
                            </div>
                        </div>

                    </div>

                </motion.div>
            )}

        </main>
    )
}
